const datasetNotificationActions = {
  SHOW_DATASET_NOTIFICATION_CREATE: 'SHOW_DATASET_NOTIFICATION_CREATE',
  HIDE_DATASET_NOTIFICATION_CREATE: 'HIDE_DATASET_NOTIFICATION_CREATE',
  UPDATE_DATASET_NOTIFICATION_CREATE_PROPERTIES: 'UPDATE_DATASET_NOTIFICATION_CREATE_PROPERTIES',
  CREATE_DATASET_NOTIFICATION: 'CREATE_DATASET_NOTIFICATION',
  CREATE_DATASET_NOTIFICATION_SUCCESS: 'CREATE_DATASET_NOTIFICATION_SUCCESS',
  CREATE_DATASET_NOTIFICATION_ERROR: 'CREATE_DATASET_NOTIFICATION_ERROR',
};

export default datasetNotificationActions;
